/* GLOSS FAQ accordions 31.10.2026: turn the FAQ block of every blog article into +/- accordions */
(function () {
  function isFaqHeading(el) {
    return el && el.tagName === 'H2' && /frequently asked|\bfaq\b/i.test(el.textContent);
  }
  function makeItem(question, nodes) {
    var d = document.createElement('details');
    d.className = 'gloss-faq__item';
    var s = document.createElement('summary');
    s.textContent = question;
    var a = document.createElement('div');
    a.className = 'gloss-faq__answer';
    nodes.forEach(function (n) { a.appendChild(n); });
    d.appendChild(s);
    d.appendChild(a);
    return d;
  }
  function build() {
    var main = document.querySelector('main[data-template^="article"]');
    if (!main) return;
    main.querySelectorAll('h2').forEach(function (h2) {
      if (!isFaqHeading(h2) || h2.dataset.glossFaq) return;
      h2.dataset.glossFaq = '1';
      var wrap = document.createElement('div');
      wrap.className = 'gloss-faq';
      var next = h2.nextElementSibling;
      if (next && next.classList.contains('faq-section')) {
        next.querySelectorAll('.faq-item').forEach(function (item) {
          var q = item.querySelector('h3');
          if (!q) return;
          var rest = Array.prototype.slice.call(item.children).filter(function (c) { return c !== q; });
          wrap.appendChild(makeItem(q.textContent.trim(), rest));
        });
        if (wrap.children.length) next.replaceWith(wrap);
        return;
      }
      var el = next, items = [];
      while (el && el.tagName === 'H3') {
        var q = el, body = [];
        el = el.nextElementSibling;
        while (el && el.tagName !== 'H3' && el.tagName !== 'H2') { body.push(el); el = el.nextElementSibling; }
        items.push([q, body]);
      }
      if (!items.length) return;
      h2.after(wrap);
      items.forEach(function (it) {
        wrap.appendChild(makeItem(it[0].textContent.trim(), it[1]));
        it[0].remove();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
